<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="100px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="爆店码标题">
                  <el-input style="width: 177px;" v-model="queryForm.hotcodeTitle"></el-input>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id"
                               :value="queryForm.userId" :limit='1'
                               size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code"
                               :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                               queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoHotcodeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addVideoHotcode"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editVideoHotcode(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteVideoHotcode(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportVideoHotcodeList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshVideoHotcodeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="videoHotcodeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="hotcodeTitle"
        label="爆店码标题"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="hotcodeDesc"
        label="爆店码描述"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoPic"
        label="剪混后的视频图片"
        min-width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.videoPic">
                  <el-image
                      @click='updateSrcList(scope.row.videoPic)'
                      style="width: 60px; height: 60px"
                      :src="scope.row.videoPic"
                      :preview-src-list="srcList"
                  > </el-image>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSrc"
        label="视频地址"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSize"
        label="视频大小"
        min-width="180"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.videoSize">
                  {{(scope.row.videoSize / 1024 / 1024).toFixed(2) + 'M'}}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        min-width="180"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.user">
                  <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                  <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                  <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                  <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="viewVideo(scop.row.videoSrc)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">播放</span>
              </div>
            <div @click="checkVideoHotcode(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editVideoHotcode(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteVideoHotcode(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="videoHotcodeStates[videoHotcodeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="videoHotcode"
          ref="videoHotcodeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="爆店码标题"
            prop="hotcodeTitle"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="videoHotcode.hotcodeTitle"
              :disabled="videoHotcodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="爆店码描述"
            prop="hotcodeDesc"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="videoHotcode.hotcodeDesc"
              :disabled="videoHotcodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="剪混后的视频图片"
            prop="videoPic"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="videoHotcode.videoPic"
              :disabled="videoHotcodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频地址"
            prop="videoSrc"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="videoHotcode.videoSrc"
              :disabled="videoHotcodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频大小"
            prop="videoSize"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="videoHotcode.videoSize"
              :disabled="videoHotcodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="videoHotcode.userId"-->
<!--              :disabled="videoHotcodeState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id"
                           :value="videoHotcode.userId" :limit='1' :disabled="videoHotcodeState == 'check'"
                           size='small' placeholder='请选择用户' @getValue="getValueUser" :columns="USER_code"
                           :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                           queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="videoHotcodeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetVideoHotcodeList();
                    this.getVideoHotcodeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetVideoHotcodeList();
                    this.getVideoHotcodeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     hotcodeTitle: '', //爆店码标题
                     hotcodeDesc: '', //爆店码描述
                     videoPic: '', //剪混后的视频图片
                     videoSrc: '', //视频地址
                     videoSize: '', //视频大小
                     userId: '', //用户ID
                },
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                videoHotcodeState: 'add',
                videoHotcodeStates: {
                    add: '新建爆店码',
                    check: '查看爆店码',
                    edit: '修改爆店码'
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                multipleSelection: [],
                videoHotcodeList: [],
                videoHotcode: {
                    id: '', //ID
                    hotcodeTitle: '', //爆店码标题
                    hotcodeDesc: '', //爆店码描述
                    videoPic: '', //剪混后的视频图片
                    videoSrc: '', //视频地址
                    videoSize: '', //视频大小
                    userId: '', //用户ID
                },
                btnLoading: false,

                rules: {
                    hotcodeTitle: [{ required: true, message: '爆店码标题不能为空', trigger: 'blur' }],
                    hotcodeDesc: [{ required: true, message: '爆店码描述不能为空', trigger: 'blur' }],
                    videoPic: [{ required: true, message: '剪混后的视频图片不能为空', trigger: 'blur' }],
                    videoSrc: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
                    videoSize: [{ required: true, message: '视频大小不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getVideoHotcodeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            getValueUser(value){
                this.videoHotcode.userId = value
            },
            viewVideo(url){
                window.open(url)
            },
            resetVideoHotcodeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.videoHotcodeList = [];
            },
            updateSrcList(url){
                this.srcList[0] = url
            },
            resetDialog() {
                this.videoHotcodeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      hotcodeTitle: '', //爆店码标题
                      hotcodeDesc: '', //爆店码描述
                      videoPic: '', //剪混后的视频图片
                      videoSrc: '', //视频地址
                      videoSize: '', //视频大小
                      userId: '', //用户ID
                };
                this.getVideoHotcodeList();
            },
            closeDialog() {
                this.showDialog = false
                this.videoHotcode = {
                      id: '', //ID
                      hotcodeTitle: '', //爆店码标题
                      hotcodeDesc: '', //爆店码描述
                      videoPic: '', //剪混后的视频图片
                      videoSrc: '', //视频地址
                      videoSize: '', //视频大小
                      userId: '', //用户ID
                };
            },
            submitForm() {
                if (this.videoHotcodeState == 'add') {
                    this.$refs.videoHotcodeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcode/add`,{ ...this.videoHotcode }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetVideoHotcodeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.videoHotcodeState == 'edit') {
                    this.$refs.videoHotcodeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/hotcode/edit`,{ ...this.videoHotcode }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetVideoHotcodeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addVideoHotcode() {
                this.showDialog = true;
                this.videoHotcodeState = 'add';
            },
            checkVideoHotcode(videoHotcodeId) {
                console.log(videoHotcodeId);
                this.currentVideoHotcodeId = videoHotcodeId;

                this.getVideoHotcodeById();
                this.showDialog = true;
                this.videoHotcodeState = 'check';
            },
            editVideoHotcode(videoHotcodeId) {
                console.log('videoHotcode', videoHotcodeId);
                if (videoHotcodeId) {
                    this.currentVideoHotcodeId = videoHotcodeId;
                    this.getVideoHotcodeById();
                } else {
                    this.videoHotcode = { ...this.videoHotcode, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.videoHotcodeState = 'edit';
            },
            deleteVideoHotcode(videoHotcodeId) {
                let ids = '';
                if (videoHotcodeId) {
                    ids = videoHotcodeId;
                } else {
                    ids = this.multipleSelection.map((videoHotcode) => videoHotcode.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/video/hotcode/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoHotcodeList();
                                this.getVideoHotcodeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshVideoHotcodeList() {
                this.resetVideoHotcodeList();
                this.getVideoHotcodeList();
            },
            getVideoHotcodeList(query = {}) {
                this.loading = true;
                get(`/video/hotcode/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.videoHotcodeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getVideoHotcodeById() {
                get(`/video/hotcode/get`,{ id: this.currentVideoHotcodeId }).then((res) =>{
                    if(res.success){
                      this.videoHotcode = { ...this.videoHotcode, ...res.videoHotcode };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportVideoHotcodeList() {
                //this.btnLoading = true;
                exprotExcel(`/video/hotcode/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/video/hotcode/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/video/hotcode/importData`,formData);
              this.refreshVideoHotcodeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getVideoHotcodeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getVideoHotcodeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>